export default {
  id: 170,
  title: 'Target #170 - Party Hat',
  url: 'https://cssbattle.dev/play/170',
  colors: ['#0D1335', '#FBFAE2', '#DC6638', '#73C6EA'],
  solution:
    '<a a><a b><a c><style>body{background:#73c6ea}a{position:fixed;bottom:60;left:75;width:250;clip-path:polygon(50% 0,0 100%,100% 100%)}[a]{height:180;background:#0d1335}[b]{height:140;background:#dc6638}[c]{height:100;background:#fbfae2}</style>',
}
